import IGVBrowser from "../components/igv/IGVBrowser";
import Banner from "../components/layouts/banner";

export default function GnomeBrowserPage() {
    return (
        <>
            <Banner />
            <div className="container my-5">
                <IGVBrowser position={0} chromosome={1} />
            </div>
        </>
    );
}
